export class I18n {
  static readonly SUPPORTED_LANGS = [
    'ar', 'bg', 'cs', 'da', 'de', 'de_CH', 'el', 'en', 'en_GB', 'es', 'es_ES', 'et', 'fi', 'fr', 'fr_CA', 'gr', 'he',
    'hu', 'id', 'it', 'ja', 'ko', 'lt', 'lv', 'nl', 'no', 'pl', 'pt', 'pt_BR', 'ro', 'ru', 'sk', 'sl', 'sv', 'th', 'tr', 'uk',
    'vi', 'zh_CN', 'zh_HK', 'zh_TW'
  ];
}
